/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 337);
/******/ })
/************************************************************************/
/******/ ({

/***/ 131:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var has = Object.prototype.hasOwnProperty;

/**
 * Decode a URI encoded string.
 *
 * @param {String} input The URI encoded string.
 * @returns {String} The decoded string.
 * @api private
 */
function decode(input) {
  return decodeURIComponent(input.replace(/\+/g, ' '));
}

/**
 * Simple query string parser.
 *
 * @param {String} query The query string that needs to be parsed.
 * @returns {Object}
 * @api public
 */
function querystring(query) {
  var parser = /([^=?&]+)=?([^&]*)/g
    , result = {}
    , part;

  //
  // Little nifty parsing hack, leverage the fact that RegExp.exec increments
  // the lastIndex property so we can continue executing this loop until we've
  // parsed all results.
  //
  for (;
    part = parser.exec(query);
    result[decode(part[1])] = decode(part[2])
  );

  return result;
}

/**
 * Transform a query string to an object.
 *
 * @param {Object} obj Object that should be transformed.
 * @param {String} prefix Optional prefix.
 * @returns {String}
 * @api public
 */
function querystringify(obj, prefix) {
  prefix = prefix || '';

  var pairs = [];

  //
  // Optionally prefix with a '?' if needed
  //
  if ('string' !== typeof prefix) prefix = '?';

  for (var key in obj) {
    if (has.call(obj, key)) {
      pairs.push(encodeURIComponent(key) +'='+ encodeURIComponent(obj[key]));
    }
  }

  return pairs.length ? prefix + pairs.join('&') : '';
}

//
// Expose the module.
//
exports.stringify = querystringify;
exports.parse = querystring;


/***/ }),

/***/ 132:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__blank_slate__ = __webpack_require__(49);
/**
 * WordPress dependencies
 */
var __ = wp.i18n.__;
var Button = wp.components.Button;

/**
 * Internal dependencies
 */



/**
 * Render No forms Found UI
*/

var NoForms = function NoForms() {
	return wp.element.createElement(
		__WEBPACK_IMPORTED_MODULE_0__blank_slate__["a" /* default */],
		{ title: __('No donation forms found.'),
			description: __('The first step towards accepting online donations is to create a form.'),
			helpLink: true },
		wp.element.createElement(
			Button,
			{ isPrimary: true,
				isLarge: true,
				href: wpApiSettings.schema.url + '/wp-admin/post-new.php?post_type=give_forms' },
			__('Create Donation Form')
		)
	);
};

/* harmony default export */ __webpack_exports__["a"] = (NoForms);

/***/ }),

/***/ 133:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * WordPress dependencies
 */
var _wp$components = wp.components,
    BaseControl = _wp$components.BaseControl,
    FormToggle = _wp$components.FormToggle;
var withInstanceId = wp.compose.withInstanceId;
var Component = wp.element.Component;

var GiveToggleControl = function (_Component) {
	_inherits(GiveToggleControl, _Component);

	function GiveToggleControl(props) {
		var _ref;

		_classCallCheck(this, GiveToggleControl);

		var _this = _possibleConstructorReturn(this, (_ref = GiveToggleControl.__proto__ || Object.getPrototypeOf(GiveToggleControl)).call.apply(_ref, [this].concat(_toConsumableArray(props))));

		_this.onChange = _this.onChange.bind(_this);
		return _this;
	}

	_createClass(GiveToggleControl, [{
		key: "onChange",
		value: function onChange(event) {
			if (this.props.onChange) {
				this.props.onChange(event);
			}
		}
	}, {
		key: "render",
		value: function render() {
			var _props = this.props,
			    label = _props.label,
			    checked = _props.checked,
			    help = _props.help,
			    instanceId = _props.instanceId,
			    name = _props.name;

			var id = "give-inspector-toggle-control-" + instanceId;

			var describedBy = void 0;
			if (help) {
				describedBy = id + '__help';
			}

			return wp.element.createElement(
				BaseControl,
				{
					label: label,
					id: id,
					help: help,
					className: "blocks-toggle-control"
				},
				wp.element.createElement(FormToggle, {
					id: id,
					name: name,
					checked: checked,
					onChange: this.onChange,
					"aria-describedby": describedBy
				})
			);
		}
	}]);

	return GiveToggleControl;
}(Component);

/* harmony default export */ __webpack_exports__["a"] = (withInstanceId(GiveToggleControl));

/***/ }),

/***/ 134:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * External dependencies
 */


/**
 * WordPress dependencies
 */
var BaseControl = wp.components.BaseControl;
var withInstanceId = wp.compose.withInstanceId;
var Component = wp.element.Component;

var GiveSelectControl = function (_Component) {
	_inherits(GiveSelectControl, _Component);

	function GiveSelectControl(props) {
		_classCallCheck(this, GiveSelectControl);

		var _this = _possibleConstructorReturn(this, (GiveSelectControl.__proto__ || Object.getPrototypeOf(GiveSelectControl)).call(this, props));

		_this.onChangeHandler = _this.onChangeHandler.bind(_this);
		return _this;
	}

	_createClass(GiveSelectControl, [{
		key: 'onChangeHandler',
		value: function onChangeHandler(event) {
			if (this.props.onChange) {
				this.props.onChange(event);
			}
		}

		// Disable reason: A select with an onchange throws a warning

	}, {
		key: 'render',
		value: function render() {
			var _props = this.props,
			    label = _props.label,
			    help = _props.help,
			    instanceId = _props.instanceId,
			    _props$options = _props.options,
			    options = _props$options === undefined ? [] : _props$options,
			    name = _props.name,
			    props = _objectWithoutProperties(_props, ['label', 'help', 'instanceId', 'options', 'name']);

			var id = 'give-inspector-select-control-' + instanceId;

			/* eslint-disable jsx-a11y/no-onchange */
			return !Object(__WEBPACK_IMPORTED_MODULE_0_lodash__["isEmpty"])(options) && wp.element.createElement(
				BaseControl,
				{ label: label, id: id, help: help },
				wp.element.createElement(
					'select',
					_extends({
						id: id,
						name: name,
						className: 'blocks-select-control__input',
						onChange: this.onChangeHandler,
						'aria-describedby': !!help ? id + '__help' : undefined
					}, props),
					options.map(function (option) {
						return wp.element.createElement(
							'option',
							{
								key: option.value,
								value: option.value
							},
							option.label
						);
					})
				)
			);
			/* eslint-enable jsx-a11y/no-onchange */
		}
	}]);

	return GiveSelectControl;
}(Component);

/* harmony default export */ __webpack_exports__["a"] = (withInstanceId(GiveSelectControl));

/***/ }),

/***/ 337:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__donation_form_index__ = __webpack_require__(338);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__donation_form_grid_index__ = __webpack_require__(355);



/***/ }),

/***/ 338:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__style_scss__ = __webpack_require__(339);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__style_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__style_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__data_icon__ = __webpack_require__(340);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__data_attributes__ = __webpack_require__(341);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__edit_block__ = __webpack_require__(342);
/**
 * WordPress dependencies
 */
var __ = wp.i18n.__;
var registerBlockType = wp.blocks.registerBlockType;

/**
 * Internal dependencies
 */






/**
 * Register Block
*/

/* unused harmony default export */ var _unused_webpack_default_export = (registerBlockType('give/donation-form', {

	title: __('Give Form'),
	description: __('The Give Donation Form block insert an existing donation form into the page. Each form\'s presentation can be customized below.'),
	category: 'widgets',
	icon: __WEBPACK_IMPORTED_MODULE_1__data_icon__["a" /* default */],
	keywords: [__('donation')],
	supports: {
		html: false
	},
	attributes: __WEBPACK_IMPORTED_MODULE_2__data_attributes__["a" /* default */],
	edit: __WEBPACK_IMPORTED_MODULE_3__edit_block__["a" /* default */],

	save: function save() {
		// Server side rendering via shortcode
		return null;
	}
}));

/***/ }),

/***/ 339:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 340:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Inline JSX SVG
*/

var giveLogo = wp.element.createElement(
	"svg",
	{ id: "Layer_1", width: "20px", height: "20px", xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink",
		viewBox: "100 0 404 400" },
	wp.element.createElement(
		"g",
		{ id: "Layer_2" },
		wp.element.createElement("circle", { fill: "#555d66", cx: "300", cy: "200", r: "200" }),
		wp.element.createElement(
			"defs",
			null,
			wp.element.createElement("circle", { id: "SVGID_1_", cx: "300", cy: "200", r: "200" })
		),
		wp.element.createElement(
			"clippath",
			{ id: "SVGID_2_" },
			wp.element.createElement("use", { xlinkHref: "#SVGID_1_", overflow: "visible" })
		),
		wp.element.createElement("path", { clipPath: "url(#SVGID_2_)", fill: "#FFF", d: "M328.5,214.2c0.8,1.8,2.5,3.3,2.5,3.3c35.4,4.3,85.5-0.5,123.7-5.6 c-21.9,47.1-61.1,78.4-96.9,78.4c-67.4,0-119.3-81.7-119.3-81.7c20.9-18.3,55.2-78.4,104.8-78.4s71.2,27.2,71.2,27.2l5.6-8.9 c0,0-23.2-81.2-88.8-81.2S195.9,175.1,155.2,199.7c0,0,56,132.8,178.6,132.8c102.8,0,128.8-98.2,133.6-122.6 c13.7-2,25.2-4.1,32.6-5.3c2.5-5.6,5.3-15.5,3.3-28.8c-41,15.8-103.1,33.6-175.8,33.6C327.2,209.4,327.5,212,328.5,214.2z"
		})
	)
);

/* harmony default export */ __webpack_exports__["a"] = (giveLogo);

/***/ }),

/***/ 341:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Block Attributes
*/

var blockAttributes = {
	id: {
		type: 'number',
		default: 0
	},
	displayStyle: {
		type: 'string',
		default: 'onpage'
	},
	continueButtonTitle: {
		type: 'string',
		default: ''
	},
	showTitle: {
		type: 'boolean',
		default: false
	},
	showGoal: {
		type: 'boolean',
		default: false
	},
	contentDisplay: {
		type: 'boolean',
		default: false
	},
	showContent: {
		type: 'string',
		default: 'none'
	}
};

/* harmony default export */ __webpack_exports__["a"] = (blockAttributes);

/***/ }),

/***/ 342:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_querystringify__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_querystringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_querystringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_blank_slate__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_no_form__ = __webpack_require__(132);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_edit_form__ = __webpack_require__(347);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__form_preview__ = __webpack_require__(348);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_form_select__ = __webpack_require__(354);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * External dependencies
 */



/**
 * WordPress dependencies
 */
var __ = wp.i18n.__;
var withAPIData = wp.components.withAPIData;
var Component = wp.element.Component;

/**
 * Internal dependencies
 */







/**
 * Render Block UI For Editor
 *
 * @class GiveForm
 * @extends {Component}
 */

var GiveForm = function (_Component) {
	_inherits(GiveForm, _Component);

	function GiveForm(props) {
		var _ref;

		_classCallCheck(this, GiveForm);

		return _possibleConstructorReturn(this, (_ref = GiveForm.__proto__ || Object.getPrototypeOf(GiveForm)).call.apply(_ref, [this].concat(_toConsumableArray(props))));
	}

	/**
  * Render block UI
  *
  * @returns {object} JSX Object
  * @memberof GiveForm
  */


	_createClass(GiveForm, [{
		key: 'render',
		value: function render() {
			var props = this.props,
			    attributes = props.attributes,
			    isLoading = props.form.isLoading;

			// Render block UI
			var blockUI = void 0;

			if (!attributes.id) {
				if (isLoading || Object(__WEBPACK_IMPORTED_MODULE_0_lodash__["isUndefined"])(props.form.data)) {
					blockUI = wp.element.createElement(__WEBPACK_IMPORTED_MODULE_2__components_blank_slate__["a" /* default */], { title: __('Loading...'), isLoader: true });
				} else if (Object(__WEBPACK_IMPORTED_MODULE_0_lodash__["isEmpty"])(props.form.data)) {
					blockUI = wp.element.createElement(__WEBPACK_IMPORTED_MODULE_3__components_no_form__["a" /* default */], null);
				} else {
					blockUI = wp.element.createElement(__WEBPACK_IMPORTED_MODULE_6__components_form_select__["a" /* default */], _extends({}, props));
				}
			} else if (Object(__WEBPACK_IMPORTED_MODULE_0_lodash__["isEmpty"])(props.form.data)) {
				blockUI = isLoading ? wp.element.createElement(__WEBPACK_IMPORTED_MODULE_2__components_blank_slate__["a" /* default */], { title: __('Loading...'), isLoader: true }) : wp.element.createElement(__WEBPACK_IMPORTED_MODULE_4__components_edit_form__["a" /* default */], _extends({ formId: attributes.id }, _extends({}, props)));
			} else {
				blockUI = wp.element.createElement(__WEBPACK_IMPORTED_MODULE_5__form_preview__["a" /* default */], _extends({
					html: props.form.data
				}, _extends({}, props)));
			}

			return wp.element.createElement(
				'div',
				{ className: !!props.isSelected ? props.className + ' isSelected' : props.className, key: 'GiveBlockUI' },
				blockUI
			);
		}
	}]);

	return GiveForm;
}(Component);

/**
 * Export component attaching withAPIdata
 */


/* harmony default export */ __webpack_exports__["a"] = (withAPIData(function (props) {
	var _props$attributes = props.attributes,
	    showTitle = _props$attributes.showTitle,
	    showGoal = _props$attributes.showGoal,
	    showContent = _props$attributes.showContent,
	    displayStyle = _props$attributes.displayStyle,
	    continueButtonTitle = _props$attributes.continueButtonTitle,
	    id = _props$attributes.id;


	var parameters = {
		show_title: showTitle,
		show_goal: showGoal,
		show_content: showContent,
		display_style: displayStyle
	};

	if ('reveal' === displayStyle) {
		parameters.continue_button_title = continueButtonTitle;
	}

	parameters = Object(__WEBPACK_IMPORTED_MODULE_1_querystringify__["stringify"])(Object(__WEBPACK_IMPORTED_MODULE_0_lodash__["pickBy"])(parameters, function (value) {
		return !Object(__WEBPACK_IMPORTED_MODULE_0_lodash__["isUndefined"])(value);
	}));

	return {
		form: '/' + giveApiSettings.rest_base + '/form/' + id + '/?' + parameters,
		forms: '/wp/v2/give_forms'
	};
})(GiveForm));

/***/ }),

/***/ 343:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
* WordPress dependencies
*/
var __ = wp.i18n.__;

/**
 * Render Help link
*/

var GiveHelpLink = function GiveHelpLink() {
	return wp.element.createElement(
		"p",
		{ className: "give-blank-slate__help" },
		"Need help ? Get started with ",
		wp.element.createElement(
			"a",
			{ href: "http://docs.givewp.com/give101/", target: "_blank", rel: "noopener noreferrer" },
			__('Give 101')
		)
	);
};

/* harmony default export */ __webpack_exports__["a"] = (GiveHelpLink);

/***/ }),

/***/ 344:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__style_scss__ = __webpack_require__(345);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__style_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__style_scss__);
/**
 * Internal dependencies
 */


var PlaceholderContainerAnimation = function PlaceholderContainerAnimation() {
	return wp.element.createElement(
		"div",
		{ className: "placeholder-container-animation" },
		wp.element.createElement(
			"div",
			{ className: "timeline-wrapper" },
			wp.element.createElement(
				"div",
				{ className: "timeline-item" },
				wp.element.createElement(
					"div",
					{ className: "animated-background" },
					wp.element.createElement(
						"div",
						{ className: "layer label layer-4" },
						wp.element.createElement("div", { className: "layer-item" }),
						wp.element.createElement("div", { className: "layer-item opaque" }),
						wp.element.createElement("div", { className: "layer-item opaque" }),
						wp.element.createElement("div", { className: "layer-item" }),
						wp.element.createElement("div", { className: "layer-item opaque" })
					),
					wp.element.createElement("div", { className: "layer-gap small" }),
					wp.element.createElement(
						"div",
						{ className: "layer h2 layer-5" },
						wp.element.createElement("div", { className: "layer-item" }),
						wp.element.createElement("div", { className: "layer-item opaque" }),
						wp.element.createElement("div", { className: "layer-item opaque" }),
						wp.element.createElement("div", { className: "layer-item" }),
						wp.element.createElement("div", { className: "layer-item opaque" })
					),
					wp.element.createElement("div", { className: "layer-gap medium" }),
					wp.element.createElement(
						"div",
						{ className: "layer label layer-6" },
						wp.element.createElement("div", { className: "layer-item" }),
						wp.element.createElement("div", { className: "layer-item opaque" })
					),
					wp.element.createElement("div", { className: "layer-gap small" }),
					wp.element.createElement(
						"div",
						{ className: "layer h2 layer-7" },
						wp.element.createElement("div", { className: "layer-item" }),
						wp.element.createElement("div", { className: "layer-item opaque" })
					),
					wp.element.createElement("div", { className: "layer-gap medium" }),
					wp.element.createElement("div", { className: "layer-gap medium" }),
					wp.element.createElement(
						"div",
						{ className: "layer h1 layer-8" },
						wp.element.createElement("div", { className: "layer-item opaque" }),
						wp.element.createElement("div", { className: "layer-item" }),
						wp.element.createElement("div", { className: "layer-item opaque" })
					)
				)
			)
		)
	);
};

/* harmony default export */ __webpack_exports__["a"] = (PlaceholderContainerAnimation);

/***/ }),

/***/ 345:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 346:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 347:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__blank_slate__ = __webpack_require__(49);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * WordPress dependencies
 */
var __ = wp.i18n.__;
var Button = wp.components.Button;
var Component = wp.element.Component;

/**
 * Internal dependencies
 */



/**
 * Render No forms Found UI
 */

var EditForm = function (_Component) {
	_inherits(EditForm, _Component);

	function EditForm(props) {
		_classCallCheck(this, EditForm);

		var _this = _possibleConstructorReturn(this, (EditForm.__proto__ || Object.getPrototypeOf(EditForm)).call(this, props));

		_this.changeForm = _this.changeForm.bind(_this);
		return _this;
	}

	_createClass(EditForm, [{
		key: 'changeForm',
		value: function changeForm() {
			this.props.setAttributes({ prevId: this.props.attributes.id });
			this.props.setAttributes({ id: 0 });
		}
	}, {
		key: 'render',
		value: function render() {
			return wp.element.createElement(
				__WEBPACK_IMPORTED_MODULE_0__blank_slate__["a" /* default */],
				{ title: __('Edit Form.'),
					description: __('You can not see donation form preview because there is something went wrong with donation form settings.') },
				wp.element.createElement(
					Button,
					{ isPrimary: true,
						isLarge: true,
						target: '_blank',
						href: wpApiSettings.schema.url + '/wp-admin/post.php?post=' + this.props.formId + '&action=edit' },
					__('Edit Donation Form')
				),
				'\xA0\xA0',
				wp.element.createElement(
					Button,
					{ isLarge: true,
						onClick: this.changeForm },
					__('Change Form')
				)
			);
		}
	}]);

	return EditForm;
}(Component);

/* harmony default export */ __webpack_exports__["a"] = (EditForm);

/***/ }),

/***/ 348:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__inspector__ = __webpack_require__(349);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__controls__ = __webpack_require__(352);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * WordPress dependencies
 */
var Component = wp.element.Component;

/**
 * Internal dependencies
*/




/**
 * Render Form Preview
 */

var FormPreview = function (_Component) {
	_inherits(FormPreview, _Component);

	function FormPreview() {
		_classCallCheck(this, FormPreview);

		return _possibleConstructorReturn(this, (FormPreview.__proto__ || Object.getPrototypeOf(FormPreview)).apply(this, arguments));
	}

	_createClass(FormPreview, [{
		key: 'render',
		value: function render() {
			return wp.element.createElement(
				'div',
				{ id: 'donation-form-preview-block' },
				wp.element.createElement(__WEBPACK_IMPORTED_MODULE_0__inspector__["a" /* default */], _extends({}, this.props)),
				wp.element.createElement(__WEBPACK_IMPORTED_MODULE_1__controls__["a" /* default */], _extends({}, this.props)),
				wp.element.createElement('div', { dangerouslySetInnerHTML: { __html: this.props.html } })
			);
		}
	}]);

	return FormPreview;
}(Component);

/* harmony default export */ __webpack_exports__["a"] = (FormPreview);

/***/ }),

/***/ 349:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_text_control__ = __webpack_require__(350);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_toggle_control__ = __webpack_require__(133);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_select_control__ = __webpack_require__(134);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__data_options__ = __webpack_require__(351);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * Wordpress dependencies
 */
var __ = wp.i18n.__;
var InspectorControls = wp.editor.InspectorControls;
var PanelBody = wp.components.PanelBody;
var Component = wp.element.Component;

/**
 * Internal dependencies
 */






/**
 * Render Inspector Controls
*/

var Inspector = function (_Component) {
	_inherits(Inspector, _Component);

	function Inspector(props) {
		_classCallCheck(this, Inspector);

		var _this = _possibleConstructorReturn(this, (Inspector.__proto__ || Object.getPrototypeOf(Inspector)).call(this, props));

		_this.state = {
			continueButtonTitle: _this.props.attributes.continueButtonTitle
		};

		_this.saveSetting = _this.saveSetting.bind(_this);
		_this.saveState = _this.saveState.bind(_this);
		return _this;
	}

	_createClass(Inspector, [{
		key: 'saveSetting',
		value: function saveSetting(event) {
			var name = event.target.name;

			this.props.setAttributes('checkbox' === event.target.type ? _defineProperty({}, name, !this.props.attributes[name]) : _defineProperty({}, name, event.target.value));
		}
	}, {
		key: 'saveState',
		value: function saveState(event) {
			this.setState(_defineProperty({}, event.target.name, event.target.value));
		}
	}, {
		key: 'render',
		value: function render() {
			return wp.element.createElement(
				InspectorControls,
				{ key: 'inspector' },
				wp.element.createElement(
					PanelBody,
					{ title: __('Display') },
					wp.element.createElement(__WEBPACK_IMPORTED_MODULE_2__components_select_control__["a" /* default */], {
						label: __('Form Format'),
						name: 'displayStyle',
						value: this.props.attributes.displayStyle,
						options: __WEBPACK_IMPORTED_MODULE_3__data_options__["a" /* default */].displayStyles,
						onChange: this.saveSetting }),
					'reveal' === this.props.attributes.displayStyle && wp.element.createElement(__WEBPACK_IMPORTED_MODULE_0__components_text_control__["a" /* default */], {
						name: 'continueButtonTitle',
						label: __('Continue Button Title'),
						value: this.state.continueButtonTitle,
						onChange: this.saveState,
						onBlur: this.saveSetting })
				),
				wp.element.createElement(
					PanelBody,
					{ title: __('Settings') },
					wp.element.createElement(__WEBPACK_IMPORTED_MODULE_1__components_toggle_control__["a" /* default */], {
						label: __('Goal'),
						name: 'showGoal',
						checked: !!this.props.attributes.showGoal,
						onChange: this.saveSetting }),
					wp.element.createElement(__WEBPACK_IMPORTED_MODULE_1__components_toggle_control__["a" /* default */], {
						label: __('Content'),
						name: 'contentDisplay',
						checked: !!this.props.attributes.contentDisplay,
						onChange: this.saveSetting }),
					this.props.attributes.contentDisplay && wp.element.createElement(__WEBPACK_IMPORTED_MODULE_2__components_select_control__["a" /* default */], {
						label: __('Content Position'),
						name: 'showContent',
						value: this.props.attributes.showContent,
						options: __WEBPACK_IMPORTED_MODULE_3__data_options__["a" /* default */].contentPosition,
						onChange: this.saveSetting })
				)
			);
		}
	}]);

	return Inspector;
}(Component);

/* harmony default export */ __webpack_exports__["a"] = (Inspector);

/***/ }),

/***/ 350:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * WordPress dependencies
 */
var Component = wp.element.Component;
var BaseControl = wp.components.BaseControl;
var withInstanceId = wp.compose.withInstanceId;

var GiveTextControl = function (_Component) {
	_inherits(GiveTextControl, _Component);

	function GiveTextControl(props) {
		var _ref;

		_classCallCheck(this, GiveTextControl);

		var _this = _possibleConstructorReturn(this, (_ref = GiveTextControl.__proto__ || Object.getPrototypeOf(GiveTextControl)).call.apply(_ref, [this].concat(_toConsumableArray(props))));

		_this.onChangeHandler = _this.onChangeHandler.bind(_this);
		return _this;
	}

	_createClass(GiveTextControl, [{
		key: 'onChangeHandler',
		value: function onChangeHandler(event) {
			if (this.props.onChange) {
				this.props.onChange(event);
			}
		}
	}, {
		key: 'onBlurHandler',
		value: function onBlurHandler(event) {
			if (this.props.onBlur) {
				this.props.onBlur(event);
			}
		}
	}, {
		key: 'render',
		value: function render() {
			var _props = this.props,
			    label = _props.label,
			    name = _props.name,
			    value = _props.value,
			    help = _props.help,
			    instanceId = _props.instanceId,
			    _props$type = _props.type,
			    type = _props$type === undefined ? 'text' : _props$type,
			    props = _objectWithoutProperties(_props, ['label', 'name', 'value', 'help', 'instanceId', 'type']),
			    id = 'inspector-text-control-' + instanceId;

			return wp.element.createElement(
				BaseControl,
				{ label: label, id: id, help: help },
				wp.element.createElement('input', _extends({ className: 'blocks-text-control__input',
					type: type,
					name: name,
					id: id,
					value: value,
					onChange: this.onChangeHandler,
					onBlur: this.onBlurHandler,
					'aria-describedby': !!help ? id + '__help' : undefined
				}, props))
			);
		}
	}]);

	return GiveTextControl;
}(Component);

/* harmony default export */ __webpack_exports__["a"] = (withInstanceId(GiveTextControl));

/***/ }),

/***/ 351:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * WordPress dependencies
*/
var __ = wp.i18n.__;

/**
 * Options data for various form selects
 */

var giveFormOptions = {};

// Form Display Styles
giveFormOptions.displayStyles = [{ value: 'onpage', label: __('Full Form') }, { value: 'modal', label: __('Modal') }, { value: 'reveal', label: __('Reveal') }, { value: 'button', label: __('One Button Launch') }];

// Form content Position
giveFormOptions.contentPosition = [{ value: 'above', label: __('Above') }, { value: 'below', label: __('Below') }];

/* harmony default export */ __webpack_exports__["a"] = (giveFormOptions);

/***/ }),

/***/ 352:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__scss_controls_scss__ = __webpack_require__(353);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__scss_controls_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__scss_controls_scss__);
/**
* WordPress dependencies
*/
var __ = wp.i18n.__;

/**
* Internal dependencies
*/



/**
 * Render Block Controls
 *
 * @param {object} props component props
 * @returns {object} JSX Object
*/
var Controls = function Controls(props) {
	// Event(s)
	var onChangeForm = function onChangeForm() {
		props.setAttributes({ prevId: props.attributes.id });
		props.setAttributes({ id: 0 });
	};

	return wp.element.createElement(
		"div",
		{ className: "give-block-controls" },
		wp.element.createElement(
			"div",
			{ className: "control-popup" },
			wp.element.createElement(
				"div",
				{ className: "control-button change-form", onClick: onChangeForm },
				wp.element.createElement(
					"div",
					null,
					wp.element.createElement("span", { className: "dashicons dashicons-image-rotate" }),
					wp.element.createElement(
						"span",
						null,
						__('Change Form')
					)
				)
			),
			wp.element.createElement(
				"a",
				{
					className: "control-button edit-form",
					href: wpApiSettings.schema.url + "/wp-admin/post.php?post=" + props.attributes.id + "&action=edit",
					target: "_blank",
					rel: "noopener noreferrer",
					tooltip: __('Edit donation form')
				},
				wp.element.createElement(
					"div",
					null,
					wp.element.createElement("span", { className: "dashicons dashicons-edit" }),
					wp.element.createElement(
						"span",
						null,
						__('Edit Form')
					)
				)
			)
		)
	);
};

/* harmony default export */ __webpack_exports__["a"] = (Controls);

/***/ }),

/***/ 353:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 354:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__blank_slate__ = __webpack_require__(49);
/**
 * External dependencies
 */


/**
 * WordPress dependencies
 */
var __ = wp.i18n.__;
var _wp$components = wp.components,
    SelectControl = _wp$components.SelectControl,
    Button = _wp$components.Button;

/**
 * Internal dependencies
 */



/**
 * Render form select UI
 */
var giveFormOptionsDefault = { value: '0', label: __('-- Select Form --') };

var FormSelect = function FormSelect(props) {
	// Event(s)
	var getFormOptions = function getFormOptions() {
		// Add API Data To Select Options

		var formOptions = [];

		if (!Object(__WEBPACK_IMPORTED_MODULE_0_lodash__["isUndefined"])(props.forms.data)) {
			formOptions = props.forms.data.map(function (form) {
				return {
					value: form.id,
					label: form.title.rendered === '' ? form.id + ' : ' + __('No form title') : form.title.rendered
				};
			});
		}
		// Add Default option
		formOptions.unshift(giveFormOptionsDefault);

		return formOptions;
	};

	var setFormIdTo = function setFormIdTo(id) {
		props.setAttributes({ id: id });
	};

	var resetFormIdTo = function resetFormIdTo() {
		props.setAttributes({ id: props.attributes.prevId });
		props.setAttributes({ prevId: 0 });
	};

	return wp.element.createElement(
		__WEBPACK_IMPORTED_MODULE_1__blank_slate__["a" /* default */],
		{ title: __('Give Donation form') },
		wp.element.createElement(SelectControl, {
			options: getFormOptions(),
			onChange: setFormIdTo
		}),
		wp.element.createElement(
			Button,
			{ isPrimary: true,
				isLarge: true, href: wpApiSettings.schema.url + '/wp-admin/post-new.php?post_type=give_forms' },
			__('Add New Form')
		),
		'\xA0\xA0',
		props.attributes.prevId && wp.element.createElement(
			Button,
			{ isLarge: true,
				onClick: resetFormIdTo },
			__('Cancel')
		)
	);
};

/* harmony default export */ __webpack_exports__["a"] = (FormSelect);

/***/ }),

/***/ 355:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__data_attributes__ = __webpack_require__(356);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__data_icon__ = __webpack_require__(357);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__edit_block__ = __webpack_require__(358);
/**
 * WordPress dependencies
 */
var __ = wp.i18n.__;
var registerBlockType = wp.blocks.registerBlockType;

/**
 * Internal dependencies
 */





/**
 * Register Block
 */

/* unused harmony default export */ var _unused_webpack_default_export = (registerBlockType('give/donation-form-grid', {

	title: __('Give Donation Form Grid'),
	description: __('The Give Donation Form Grid block insert an existing donation form into the page. Each form\'s presentation can be customized below.'),
	category: 'widgets',
	icon: __WEBPACK_IMPORTED_MODULE_1__data_icon__["a" /* default */],
	keywords: [__('donation'), __('grid')],
	supports: {
		html: false
	},
	attributes: __WEBPACK_IMPORTED_MODULE_0__data_attributes__["a" /* default */],
	edit: __WEBPACK_IMPORTED_MODULE_2__edit_block__["a" /* default */],

	save: function save() {
		// Server side rendering via shortcode
		return null;
	}
}));

/***/ }),

/***/ 356:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Block Attributes
*/

var blockAttributes = {
	columns: {
		type: 'string',
		default: '4'
	},
	showExcerpt: {
		type: 'boolean',
		default: false
	},
	showGoal: {
		type: 'boolean',
		default: false
	},
	showFeaturedImage: {
		type: 'boolean',
		default: false
	},
	displayType: {
		type: 'string',
		default: 'redirect'
	}
};

/* harmony default export */ __webpack_exports__["a"] = (blockAttributes);

/***/ }),

/***/ 357:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Inline JSX SVG
*/

var giveLogo = wp.element.createElement(
	"svg",
	{ id: "Layer_1", width: "20px", height: "20px", xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink",
		viewBox: "100 0 404 400" },
	wp.element.createElement(
		"g",
		{ id: "Layer_2" },
		wp.element.createElement("circle", { fill: "#555d66", cx: "300", cy: "200", r: "200" }),
		wp.element.createElement(
			"defs",
			null,
			wp.element.createElement("circle", { id: "SVGID_1_", cx: "300", cy: "200", r: "200" })
		),
		wp.element.createElement(
			"clippath",
			{ id: "SVGID_2_" },
			wp.element.createElement("use", { xlinkHref: "#SVGID_1_", overflow: "visible" })
		),
		wp.element.createElement("path", { clipPath: "url(#SVGID_2_)", fill: "#FFF", d: "M328.5,214.2c0.8,1.8,2.5,3.3,2.5,3.3c35.4,4.3,85.5-0.5,123.7-5.6 c-21.9,47.1-61.1,78.4-96.9,78.4c-67.4,0-119.3-81.7-119.3-81.7c20.9-18.3,55.2-78.4,104.8-78.4s71.2,27.2,71.2,27.2l5.6-8.9 c0,0-23.2-81.2-88.8-81.2S195.9,175.1,155.2,199.7c0,0,56,132.8,178.6,132.8c102.8,0,128.8-98.2,133.6-122.6 c13.7-2,25.2-4.1,32.6-5.3c2.5-5.6,5.3-15.5,3.3-28.8c-41,15.8-103.1,33.6-175.8,33.6C327.2,209.4,327.5,212,328.5,214.2z"
		})
	)
);

/* harmony default export */ __webpack_exports__["a"] = (giveLogo);

/***/ }),

/***/ 358:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_querystringify__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_querystringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_querystringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_blank_slate__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_no_form__ = __webpack_require__(132);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_preview__ = __webpack_require__(359);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * External dependencies
 */



/**
 * Wordpress dependencies
 */
var __ = wp.i18n.__;
var withAPIData = wp.components.withAPIData;
var Component = wp.element.Component;

/**
 * Internal dependencies
 */





/**
 * Render Block UI For Editor
 *
 * @class GiveDonationFormGrid
 * @extends {Component}
 */

var GiveDonationFormGrid = function (_Component) {
	_inherits(GiveDonationFormGrid, _Component);

	function GiveDonationFormGrid(props) {
		var _ref;

		_classCallCheck(this, GiveDonationFormGrid);

		return _possibleConstructorReturn(this, (_ref = GiveDonationFormGrid.__proto__ || Object.getPrototypeOf(GiveDonationFormGrid)).call.apply(_ref, [this].concat(_toConsumableArray(props))));
	}

	/**
  * Render block UI
  *
  * @returns {object} JSX Object
  * @memberof GiveDonationFormGrid
  */


	_createClass(GiveDonationFormGrid, [{
		key: 'render',
		value: function render() {
			var props = this.props,
			    latestForms = props.latestForms,
			    isLoading = latestForms.isLoading;

			// Render block UI
			var blockUI = void 0;

			if (isLoading || Object(__WEBPACK_IMPORTED_MODULE_0_lodash__["isUndefined"])(latestForms.data)) {
				blockUI = wp.element.createElement(__WEBPACK_IMPORTED_MODULE_2__components_blank_slate__["a" /* default */], { title: __('Loading...'), isLoader: true });
			} else if (Object(__WEBPACK_IMPORTED_MODULE_0_lodash__["isEmpty"])(latestForms.data)) {
				blockUI = wp.element.createElement(__WEBPACK_IMPORTED_MODULE_3__components_no_form__["a" /* default */], null);
			} else {
				blockUI = wp.element.createElement(__WEBPACK_IMPORTED_MODULE_4__components_preview__["a" /* default */], _extends({
					html: latestForms.data
				}, _extends({}, props)));
			}

			return wp.element.createElement(
				'div',
				{ className: props.className, key: 'GiveDonationFormGridBlockUI' },
				blockUI
			);
		}
	}]);

	return GiveDonationFormGrid;
}(Component);

/**
 * Export component attaching withAPIdata
 */


/* harmony default export */ __webpack_exports__["a"] = (withAPIData(function (props) {
	var _props$attributes = props.attributes,
	    columns = _props$attributes.columns,
	    showGoal = _props$attributes.showGoal,
	    showExcerpt = _props$attributes.showExcerpt,
	    showFeaturedImage = _props$attributes.showFeaturedImage,
	    displayType = _props$attributes.displayType;


	var parameters = Object(__WEBPACK_IMPORTED_MODULE_1_querystringify__["stringify"])(Object(__WEBPACK_IMPORTED_MODULE_0_lodash__["pickBy"])({
		columns: columns,
		show_goal: showGoal,
		show_excerpt: showExcerpt,
		show_featured_image: showFeaturedImage,
		display_type: displayType
	}, function (value) {
		return !Object(__WEBPACK_IMPORTED_MODULE_0_lodash__["isUndefined"])(value);
	}));

	return {
		latestForms: '/' + giveApiSettings.rest_base + '/form-grid/?' + parameters
	};
})(GiveDonationFormGrid));

/***/ }),

/***/ 359:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__inspector__ = __webpack_require__(360);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Internal dependencies
 */


/**
 * Render Form Preview
 */

var FormGridPreview = function FormGridPreview(props) {
	return wp.element.createElement(
		"div",
		{ id: "donation-form-grid-preview-block" },
		wp.element.createElement(__WEBPACK_IMPORTED_MODULE_0__inspector__["a" /* default */], _extends({}, props)),
		wp.element.createElement("div", { dangerouslySetInnerHTML: { __html: props.html } })
	);
};

/* harmony default export */ __webpack_exports__["a"] = (FormGridPreview);

/***/ }),

/***/ 360:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_toggle_control_index__ = __webpack_require__(133);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_select_control_index__ = __webpack_require__(134);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__data_options__ = __webpack_require__(361);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * WordPress dependencies
 */
var __ = wp.i18n.__;
var InspectorControls = wp.editor.InspectorControls;
var PanelBody = wp.components.PanelBody;
var Component = wp.element.Component;

/**
 * Internal dependencies
 */





/**
 * Render Inspector Controls
*/

var Inspector = function (_Component) {
	_inherits(Inspector, _Component);

	function Inspector(props) {
		_classCallCheck(this, Inspector);

		var _this = _possibleConstructorReturn(this, (Inspector.__proto__ || Object.getPrototypeOf(Inspector)).call(this, props));

		_this.saveSetting = _this.saveSetting.bind(_this);
		return _this;
	}

	_createClass(Inspector, [{
		key: 'saveSetting',
		value: function saveSetting(event) {
			var name = event.target.name;

			this.props.setAttributes('checkbox' === event.target.type ? _defineProperty({}, name, !this.props.attributes[name]) : _defineProperty({}, name, event.target.value));
		}
	}, {
		key: 'render',
		value: function render() {
			return wp.element.createElement(
				InspectorControls,
				{ key: 'inspector' },
				wp.element.createElement(
					PanelBody,
					{ title: __('Settings') },
					wp.element.createElement(__WEBPACK_IMPORTED_MODULE_1__components_select_control_index__["a" /* default */], {
						label: __('Columns'),
						name: 'columns',
						value: this.props.attributes.columns,
						options: __WEBPACK_IMPORTED_MODULE_2__data_options__["a" /* default */].columns,
						onChange: this.saveSetting }),
					wp.element.createElement(__WEBPACK_IMPORTED_MODULE_0__components_toggle_control_index__["a" /* default */], {
						name: 'showExcerpt',
						label: __('Show Excerpt'),
						checked: !!this.props.attributes.showExcerpt,
						onChange: this.saveSetting }),
					wp.element.createElement(__WEBPACK_IMPORTED_MODULE_0__components_toggle_control_index__["a" /* default */], {
						name: 'showGoal',
						label: __('Show Goal'),
						checked: !!this.props.attributes.showGoal,
						onChange: this.saveSetting }),
					wp.element.createElement(__WEBPACK_IMPORTED_MODULE_0__components_toggle_control_index__["a" /* default */], {
						name: 'showFeaturedImage',
						label: __('Show Featured Image'),
						checked: !!this.props.attributes.showFeaturedImage,
						onChange: this.saveSetting }),
					wp.element.createElement(__WEBPACK_IMPORTED_MODULE_1__components_select_control_index__["a" /* default */], {
						label: __('Display Type'),
						name: 'displayType',
						value: this.props.attributes.displayType,
						options: __WEBPACK_IMPORTED_MODULE_2__data_options__["a" /* default */].displayType,
						onChange: this.saveSetting })
				)
			);
		}
	}]);

	return Inspector;
}(Component);

/* harmony default export */ __webpack_exports__["a"] = (Inspector);

/***/ }),

/***/ 361:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * WordPress dependencies
 */
var __ = wp.i18n.__;

/**
 * Options data for various form selects
 */

var giveFormOptions = {};

// Form Display Styles
giveFormOptions.columns = [{ value: '1', label: '1' }, { value: '2', label: '2' }, { value: '3', label: '3' }, { value: '4', label: '4' }];

// Form Display Styles
giveFormOptions.displayType = [{ value: 'redirect', label: __('Redirect') }, { value: 'modal', label: __('Modal') }];

/* harmony default export */ __webpack_exports__["a"] = (giveFormOptions);

/***/ }),

/***/ 49:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__help_link__ = __webpack_require__(343);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__container_placeholder_animation__ = __webpack_require__(344);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__style_scss__ = __webpack_require__(346);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__style_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__style_scss__);
/**
* WordPress dependencies
*/
var __ = wp.i18n.__;

/**
* Internal dependencies
*/





var GiveBlankSlate = function GiveBlankSlate(props) {
	var noIcon = props.noIcon,
	    isLoader = props.isLoader,
	    title = props.title,
	    description = props.description,
	    children = props.children,
	    helpLink = props.helpLink;

	// @todo: do not hard code wp content url that can be configure.

	var giveLogo = '/wp-content/plugins/Give/assets/dist/images/give-icon-full-circle.svg';

	var blockLoading = wp.element.createElement(__WEBPACK_IMPORTED_MODULE_1__container_placeholder_animation__["a" /* default */], null);

	var blockLoaded = wp.element.createElement(
		'div',
		{ className: 'block-loaded' },
		!!title && wp.element.createElement(
			'h2',
			{ className: 'give-blank-slate__heading' },
			title
		),
		!!description && wp.element.createElement(
			'p',
			{ className: 'give-blank-slate__message' },
			description
		),
		children,
		!!helpLink && wp.element.createElement(__WEBPACK_IMPORTED_MODULE_0__help_link__["a" /* default */], null)
	);

	return wp.element.createElement(
		'div',
		{ className: 'give-blank-slate' },
		!noIcon && wp.element.createElement('img', { className: 'give-blank-slate__image',
			src: '' + wpApiSettings.schema.url + giveLogo,
			alt: __('Give Icon') }),
		!!isLoader ? blockLoading : blockLoaded
	);
};

/* harmony default export */ __webpack_exports__["a"] = (GiveBlankSlate);

/***/ }),

/***/ 65:
/***/ (function(module, exports) {

module.exports = lodash;

/***/ })

/******/ });


// WEBPACK FOOTER //
// js/gutenberg.js